import { useQuery } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { queryKeys } from './queryKeys'

export const useQueryMasterFieldDefsByMasterUuid = (masterUuid: string) => {
  return useQuery({
    queryKey: queryKeys.masterFieldDefs(masterUuid),
    queryFn: () =>
      baseClient.getApi(MasterApi).getMasterFieldDefs({ masterUuid }),
    staleTime: 0,
    gcTime: 0,
    enabled: !!masterUuid,
    throwOnError: true,
  })
}
